import { Resource } from "@evergis/react-fetching/es/createResource";
import { layerWithTable } from "./layerWithTable";
import { table, tables, tableWithRefs } from "./tables";
import { layer, layerInfos, layerInfosWithDeps, layers } from "./layers";
import { project, projectInfosWithDeps, projects } from "./projects";

export type ResourceNames = {
  projects?: string[];
  layers?: string[];
  tables?: string[];
};

export const invalidate =
  <D, M, R extends Resource<string, D, M>>(...resources: R[]) =>
  (name: string) =>
    resources.map(resource => resource.invalidate(name));

export const invalidateAll = <I, D, M, R extends Resource<I, D, M>>(...resources: R[]) =>
  resources.map(resource => resource.invalidateAll());

export function invalidateResources(projectsName: string[] = [], layersName: string[] = [], tablesName: string[] = []) {
  projectsName.map(invalidate(project));
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore TODO have no idea how to solve it fast
  projectsName.length && invalidateAll(projects, projectInfosWithDeps);

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore TODO
  layersName.map(invalidate(layer, layerWithTable));
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore TODO
  layersName.length && invalidateAll(layers, layerInfos, layerInfosWithDeps, projectInfosWithDeps);

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore TODO
  tablesName.map(invalidate(table, tableWithRefs));
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore TODO
  tablesName.length && invalidateAll(tables, layerInfos);
}

export const invalidateTable = (tableName: string, layerRefs: string[] = []) => {
  invalidateResources([], layerRefs, [tableName]);
};

export const invalidateLayer = (layerName: string) => {
  invalidateResources([], [layerName]);
};
